<template>
  <div class="toast" @click.stop="$emit('cancel')">
    <div class="inner" @click.stop>

      <div class="content">
        <h2>{{question}}</h2>
        <div class="button-wrap">
          <button class="btn" @click.stop="$emit('confirm')">{{confirmText}}</button>
          <button class="btn btn-flat" @click.stop="$emit('cancel')">{{cancelText}}</button>
        </div>
      </div>
      <div class="header">
        <span @click.stop="$emit('cancel')" class="close-button">X</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmToast',
  props: ['question', 'confirmText', 'cancelText']
}
</script>

<style lang="scss" scoped>
@import 'src/color.scss';

  .toast {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $transparent-fill;

    .inner {
      position: relative;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 50%;
      height: 33%;
      padding: 1em;
      background: white;
      border: 2px solid $primary-dark;
      border-radius: 2em;

      .header, .content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 1em;
        box-sizing: border-box;
      }

      .header {
        justify-content: flex-start;
        align-items: flex-end;
        height: initial;
      }

      .content {
        flex: 1;
        flex-direction: column;
        align-content: center;
        justify-content: center;
      }

      h2 {
        margin: 0 0 1em 0;
      }
    }
  }

  .button-wrap {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  button {
    display: inline-block;
    flex: 1;
  }

  button:first-child {
    margin-right: 1em;
  }

  .close-button {
    font-size: 200%;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/ConfirmToast.vue